import { render, staticRenderFns } from "./Glance.vue?vue&type=template&id=2230ff72"
import script from "./Glance.vue?vue&type=script&lang=js"
export * from "./Glance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports